// B3 — shared renderer for /search snippets: the backend wraps the literal hit in ⟦ ⟧
// markers (plain text, never HTML) so we can safely highlight it without any injection risk.
export function renderSnippet(snippet) {
  if (!snippet) return null;
  const parts = snippet.split(/⟦|⟧/);
  if (parts.length === 1) return snippet;
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <mark key={i} className="bg-transparent text-tw-yellow font-semibold">{part}</mark>
    ) : (
      <span key={i}>{part}</span>
    )
  );
}
